import React, { useState, useRef, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import Sidebar from "components/layout/Sidebar";
import useDashboardRoutes from "../hooks/useDashboardRoutes";
import sidebarImage from "../assets/img/sidebar-3.jpg";
import Header from "components/layout/Header";
import Report from "../features/portal/reports/Report";
import OffboardForAdmins from "../features/portal/offboarding/OffboardForAdmins";
import Offboard from "../features/portal/offboarding/Offboard";
import PoliciesIndex from "../features/portal/Policies/index";
import Pendingrequest from "../features/portal/pendingRequest/Pendingrequest";
import LeaveRequestList from "../features/portal/pendingRequest/LeaveRequestList";
import DocumentRequestList from "../features/portal/pendingRequest/DocumentRequestList";
import AssetRequestList from "../features/portal/pendingRequest/AssetRequestList";
import ScheduleMeeting from "../features/portal/offboarding/ScheduleMeeting";
import ChecklistApproval from "../features/portal/offboarding/ChecklistApproval";
import FinalClearance from "../features/portal/offboarding/FinalClearance";
import Permission from "../features/portal/permission/Permission";
import CandidateDetailsForm from "../features/portal/candidate/CandidateDetailsForm";
import ViewUsers from "../features/portal/role/ViewUsers";
import ProtectedRoutes from "components/common/routing/ProtectedRoutes";
import AllDoumentsList from "../features/portal/MeSection/MyDocuments/AllDocumentsList";
import EmployeeProfile from "../features/portal/MeSection/MyDocuments/EmployeeProfile";
import PageNotFound from "PageNotFound";
import EmpReport from "../features/portal/reports/EmpReport";
import ReportPage from "../features/portal/reports/ReportPage";
import Policies from "../features/portal/MeSection/MyDocuments/Policy";
import RegisterPage from "../features/preOnboarding/pages/RegisterPage";
import AnnouncementsIndex from "../features/portal/Announcements";
import { useSelector } from "react-redux";
import EmployeeTicketPage from "../features/portal/support/employee/EmployeeTicketPage";
import CreateTicket from "../features/portal/support/employee/CreateTicketPage";
import TicketDetail from "features/portal/support/employee/TicketDetailsPage";

import HRTicketDashboard from "features/portal/support/hr/HRTicketDashboard";
import TicketReviewPage from "features/portal/support/hr/TicketReviewPage";
import Settings from "features/settings/Settings";
import PublishHoliday from "../features/portal/holidays/PublishHoliday";
import DepartmentsIndex from "../features/portal/Departments";
import DesignationsIndex from "../features/portal/Designation";

function Admin() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [image] = useState(sidebarImage);
  const [color] = useState("black");
  const [hasImage] = useState(true);
  const mainPanel = useRef(null);

  const dashboardRoutes = useDashboardRoutes();

  const { isPolicyAccepted, isJoiningFormCompleted, isExistingEmp } =
    useSelector((state) => state?.persistedReducer?.forms?.savedPermissions) ||
    {};
  const currentRole = localStorage.getItem("role");
  const isSuperAdmin = currentRole === "SUPER_ADMIN";
  const isDisabled =
    (!isJoiningFormCompleted || !isPolicyAccepted || isExistingEmp) &&
    !isSuperAdmin;

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".sidebar") && !e.target.closest(".menu-icon")) {
        setSidebarOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  // 2. Dynamic Route Generator
  const getRoutes = (routes) => {
    let allRoutes = [];

    routes.forEach((prop) => {
      const isMeSection = prop.path === "/admin/my-details";
      if (isDisabled && !isMeSection) {
        return;
      }

      if (prop.component) {
        allRoutes.push(createRoute(prop));
      }

      if (prop.children) {
        prop.children.forEach((child) => {

          const isChildMe = child.path === "/admin/my-details";
          if (isDisabled && !isChildMe) return;

          allRoutes.push(createRoute(child));
        });
      }
    });

    return allRoutes;
  };

  // Helper to keep code clean
  const createRoute = (prop) => {
    const subPath = prop.path.replace("/admin/", "");
    return (
      <Route
        path={subPath}
        key={prop.path}
        element={
          prop.permissionKey ? (
            <ProtectedRoutes permissionKey={prop.permissionKey}>
              <prop.component />
            </ProtectedRoutes>
          ) : (
            <prop.component />
          )
        }
      />
    );
  };

  return (
    <div className="wrapper">
      <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
      <Sidebar
        color={color}
        image={hasImage ? image : ""}
        routes={dashboardRoutes}
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
      />
      <div className="main-panel" ref={mainPanel}>
        <div className="content">
          <Routes>
            {getRoutes(dashboardRoutes)}
            {/* <Route path="holidays-publish/:year" element={<PublishHoliday />} /> */}
            <Route path="holidays-publish" element={<PublishHoliday />} />
            {/* 3. Render all routes defined in your routes.js dynamically */}
            {!isDisabled ? (<>
              <Route path="candidate/register" element={<RegisterPage />} />
              <Route path="/employee/details/:id" element={<EmployeeProfile />} />
              <Route path="pendingrequest" element={<Pendingrequest />} />
              <Route path="pendingrequest/leave-request-list" element={<LeaveRequestList />} />
              <Route path="pendingrequest/document-request-list" element={<DocumentRequestList />} />
              <Route path="document-request-list" element={<DocumentRequestList />} />
              <Route path="pendingrequest/asset-request-list" element={<AssetRequestList />} />
              <Route path="policies/*" element={<PoliciesIndex />} />
              <Route path="announcements/*" element={<AnnouncementsIndex />} />
              <Route path="document-request-list/report" element={<Report />} />
              <Route path="employee-report" element={<EmpReport />} />

              <Route path="support/create-ticket" element={<CreateTicket />} />
              <Route path="support/view-ticket/:id" element={<TicketDetail />} />
              <Route path="support/hr" element={<HRTicketDashboard />} />
              <Route path="support/hr/ticket/:id" element={<TicketReviewPage />} />
              <Route path="departments/*" element={<DepartmentsIndex />} />
              <Route path="designations/*" element={<DesignationsIndex />} />

              <Route path="role/view-users" element={
                <ProtectedRoutes permissionKey="Role-view">
                  <ViewUsers />
                </ProtectedRoutes>
              } />
              <Route
                path="permission/view-users"
                element={
                  <ProtectedRoutes permissionKey="Permission-view">
                    <ViewUsers />
                  </ProtectedRoutes>
                }
              />
              <Route path="role/view-users/:id" element={
                <ProtectedRoutes permissionKey="Assign/Remove Permission-view">
                  <Permission />
                </ProtectedRoutes>
              } />
              <Route path="settings" element={
                <ProtectedRoutes permissionKey="Settings-view">
                  <Settings />
                </ProtectedRoutes>
              } />
              <Route path="mydocuments" element={<AllDoumentsList />} />
              <Route path="offboarded/policies" element={<Policies />} />
              <Route path="offboard" element={<Offboard />} />
              <Route path="offboarded" element={<OffboardForAdmins />} />
              <Route path="pendingrequest/offboarded" element={<OffboardForAdmins />} />
              <Route path="offboarded/schedule-meeting" element={<ScheduleMeeting />} />
              <Route path="schedule-meeting/checklist" element={<ChecklistApproval />} />
              <Route path="checklist/final-clearance" element={<FinalClearance />} />
              <Route path="offboard" element={<Offboard />} />
              <Route path="candidate/details/:id" element={
                <ProtectedRoutes permissionKey="Candidate Details-view">
                  <CandidateDetailsForm />
                </ProtectedRoutes>
              } />
              <Route path="offboarded" element={<OffboardForAdmins />}>
                <Route path="schedule-meeting" element={<ScheduleMeeting />} />
                <Route path="checklist" element={<ChecklistApproval />} />
                <Route path="final-clearance" element={<FinalClearance />} />
                <Route path="report" element={<Report />} />
              </Route>
            </>) : (
              <Route path="*" element={<PageNotFound />} />)}
          </Routes>
        </div>
      </div>
    </div>
  );
}
export default Admin;